export default "__VITE_ASSET__De6qh1ev__"